import React, { useEffect, useState } from 'react';
// import { makeStyles } from '@material-ui/core';

// const useStyles = makeStyles(() => ({
//   container: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: '24px',
//     width: '100%'
//   }
// }));

const TemplateVisualizer = ({ data, selectedDataItem }) => {
  const [modifiedHtml, setModifiedHtml] = useState(null);
  const template1 = data.step1.template.content;
  const replaceVariables = (template, itemData) => {
    const matchesDoubleBraces = template.match(/\{\{(.*?)\}\}/g);
    const matchesTripleBraces = template.match(/\{\{\{(.*?)\}\}\}/g);

    let modifiedTemplate = template;

    if (matchesTripleBraces) {
      matchesTripleBraces.forEach(match => {
        const variable = match.slice(3, -3);
        const splitString = variable.split('.');
        const isolatedVariable = splitString[splitString.length - 1];
        if (variable.startsWith('metadata.') && itemData[isolatedVariable]) {
          const value = itemData[isolatedVariable];
          modifiedTemplate = modifiedTemplate.replace(match, value || '');
        }
      });
    }

    if (matchesDoubleBraces) {
      matchesDoubleBraces.forEach(match => {
        const variable = match.slice(2, -2);
        const splitString = variable.split('.');
        const isolatedVariable = splitString[splitString.length - 1];

        if (variable.startsWith('metadata.') && itemData[isolatedVariable]) {
          const value = itemData[isolatedVariable];
          modifiedTemplate = modifiedTemplate.replace(match, value || '');
        }
      });
    }

    return modifiedTemplate;
  };
  useEffect(() => {
    if (selectedDataItem) {
      const newModifiedHtml = replaceVariables(template1, selectedDataItem);
      setModifiedHtml(newModifiedHtml);
    }
  }, [selectedDataItem]);

  return (
    <div style={{
      marginTop: '60px'
    }}>
      { selectedDataItem ? <div dangerouslySetInnerHTML={{ __html: modifiedHtml }} /> : 'no plantilla'}
    </div>
  );
};
export default TemplateVisualizer
;
